import {SmsMessageRestService} from './restServices';
import storageService from '../storageService';

////////////////////// Service Template Head  /////////////////////////

// let privateState = {}; // private variables for this service.
// let alreadyInitiated = false;
let service = {};

////////////////////// End Service Template Head  /////////////////////////

////////////////////// Start Service Implementation:  /////////////////////////
service.sendSmsMessageToMentorByUserId = function (
  smsMessageDto,
  successCallbackFunction,
  failCallbackFunction,
  token,
) {
  var newMailMessageToMentor = {
    token: token ? token : storageService.getItem('token'),
    smsMessageDto: smsMessageDto,
  };

  SmsMessageRestService.save(
    {
      endpoint: 'userId',
    },
    newMailMessageToMentor,
    function (resource) {
      if (successCallbackFunction) successCallbackFunction(resource);
    }, // success
    function (response) {
      if (failCallbackFunction) failCallbackFunction(response);
    },
  ); // failure
};

const smsMessageService = {...service};
export default smsMessageService;
